<template>
  <input v-model="state" :class="$style.BaseInput" type="text" />
</template>
<script>
import AsyncVModel from '../../mixins/async-vmodel';

export default {
  name: 'TextInput',
  mixins: [AsyncVModel],
  props: {
    value: {
      type: [String, Number],
      default: null,
      required: false
    }
  }
};
</script>
<style
  lang="scss"
  src="../../scss/components/input/TextInput.scss"
  module
></style>
